var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleLeftLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.457,
    height: 21.457,
    viewBox: "0 0 21.457 21.457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(0 21.457) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(5.364 6.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-chevron-thin-right",
    "data-name": "Icon metro-chevron-thin-right",
    d: "M4.7,5.505.129,10.255a.446.446,0,0,0,0,.627.436.436,0,0,0,.62,0L5.762,5.819a.446.446,0,0,0,0-.627L.749.13a.435.435,0,0,0-.62,0,.446.446,0,0,0,0,.627L4.7,5.505Z",
    transform: "translate(0 5.891) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    y2: 8.761,
    transform: "translate(5.501 0.971)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_93",
    "data-name": "Path 93",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.729,21.457A10.729,10.729,0,1,0,0,10.729,10.729,10.729,0,0,0,10.729,21.457Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.728515625 20.45703506469727 C 16.09283638000488 20.45703506469727 20.45703506469727 16.09283638000488 20.45703506469727 10.728515625 C 20.45703506469727 5.364195823669434 16.09283638000488 1.000005602836609 10.728515625 1.000005602836609 C 5.364195823669434 1.000005602836609 1.000005602836609 5.364195823669434 1.000005602836609 10.728515625 C 1.000005602836609 16.09283638000488 5.364195823669434 20.45703506469727 10.728515625 20.45703506469727 M 10.728515625 21.45703506469727 C 4.80331563949585 21.45703506469727 5.625000085274223e-06 16.65371513366699 5.625000085274223e-06 10.728515625 C 5.625000085274223e-06 4.80331563949585 4.80331563949585 5.625000085274223e-06 10.728515625 5.625000085274223e-06 C 16.65371513366699 5.625000085274223e-06 21.45703506469727 4.80331563949585 21.45703506469727 10.728515625 C 21.45703506469727 16.65371513366699 16.65371513366699 21.45703506469727 10.728515625 21.45703506469727 Z",
    stroke: "none",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleLeftLight);
export default __webpack_public_path__ + "static/media/arrow-circle-left-light.cf5958aa3c22a38cbd85141ac9f8d549.svg";
export { ForwardRef as ReactComponent };